<ng-container [formGroup]="form">
  <mat-label style="font-size: 11px; padding-bottom: 0.5em; display: block">Days to Include</mat-label>
  <div class="flex-container">
    @for (day of daysOfWeek; track day) {
      <div>
        <mat-checkbox style="padding-right: 1em" [formControlName]="day">{{ day.substring(0, 2) }}</mat-checkbox>
      </div>
    }
  </div>
</ng-container>
